import React, { useEffect, useState } from "react";
import "./Sidebar.scss";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";


const Sidebar = ({children, links }) => {
  const history = useHistory();
  const {
    location: { pathname },
  } = history;

  const updateLink = (path) => {
    return path === "/" ? links[0].path : path;
  };
  const [selectedLink, setSelectedLink] = useState(updateLink(pathname));
  
  useEffect(() => {
    history.listen((location) => {
      setSelectedLink(updateLink(location.pathname));
    });
  });

  const menu = (links) => {
    return <ul className="menu">
            {links.map(({ link, icon, path, child }, index) => {
              return(
                <li
                  key={index}
                  onClick={() => child != null && setSelectedLink(path)}
                  style={{
                    
                    borderRadius: selectedLink === path && "4px",
                  }}
                >
                  
                  <Link
                  className="item"
                  to={path ? path : `/${link.toLowerCase()}`}
                  style={{ color: selectedLink === path && "#5c157d", backgroundColor:
                  selectedLink === path && "rgba(187, 157, 199, 0.2)" }}
                  >
                    {icon}
                    <span>{link}</span>
                  </Link>
                  
                  {child != null ? <div className="submenu">{menu(child)}</div> : ''}
                </li>
              )
            })}
          </ul>
        
    
          
  }

  return (
    <>
      <header className="main-head">
        <nav className="head-nav">
          {menu(links)}
        </nav>
      </header>
      <div className="wrap-all-the-things main-content">{children}</div>
    </>
  );
};

Sidebar.propTypes = {
  children: PropTypes.object.isRequired,
  links: PropTypes.array.isRequired,
};
export default Sidebar;
